const Hmac = require('../entities/hmac');

const diff = require('../utils/diff');

const propertyFields = ['id', 'name', 'secret', 'propertyId'];
const businessFields = ['id', 'name', 'secret', 'businessId'];

const parse = (json
/*: Object*/
) =>
/*: Hmac*/
new Hmac({
  id: json.id,
  name: json.name,
  propertyId: json.propertyId,
  businessId: json.businessId,
  secret: json.secret
});

const serialize = (hmac
/*: Hmac*/
) => (
/*: Object*/
{
  name: hmac.name
});

class HmacsRepo {
  constructor(client
  /*: ApiClient*/
  , context
  /*: AccessContext*/
  ) {
    this.client = client;
    this.context = context;
  }

  list()
  /*: Promise<PagedList<Hmac>>*/
  {
    const {
      propertyId,
      businessId
    } = this.context.serialize();
    const path = propertyId ? `/properties/${propertyId}/hmacs` : `/businesses/${businessId}/hmacs`;
    const fields = propertyId ? propertyFields : businessFields;
    const req = new this.client.Request(path, {}, fields);
    req.parse = parse;
    return this.client.get(req);
  }

  details(hmacId
  /*: string*/
  )
  /*: Promise<Hmac>*/
  {
    const {
      propertyId,
      businessId
    } = this.context.serialize();
    const path = propertyId ? `/properties/${propertyId}/hmacs/${hmacId}` : `/businesses/${businessId}/hmacs/${hmacId}`;
    const fields = propertyId ? propertyFields : businessFields;
    const req = new this.client.Request(path, {}, fields);
    req.parse = parse;
    return this.client.get(req);
  }

  create(hmac
  /*: Hmac | Object*/
  )
  /*: Promise<Hmac>*/
  {
    const {
      propertyId,
      businessId
    } = this.context.serialize();
    const path = propertyId ? `/properties/${propertyId}/hmacs` : `/businesses/${businessId}/hmacs`;
    const fields = propertyId ? propertyFields : businessFields;
    const req = new this.client.Request(path, hmac, fields);
    req.parse = parse;
    req.serialize = serialize;
    return this.client.post(req);
  }

  update(instance
  /*: Hmac*/
  , updates
  /*: Hmac*/
  ) {
    if (!instance.id) throw new Error('Missing required HMAC property: id');
    const hmacId = instance.id;
    const {
      propertyId,
      businessId
    } = this.context.serialize();
    const path = propertyId ? `/properties/${propertyId}/hmacs/${hmacId}` : `/businesses/${businessId}/hmacs/${hmacId}`;
    const fields = propertyId ? propertyFields : businessFields;
    const updatedProps = diff(instance, updates);
    const req = new this.client.Request(path, updatedProps, fields);
    req.parse = parse;
    req.serialize = serialize;
    return this.client.patch(req);
  }

  delete(hmacId
  /*: string*/
  )
  /*: Promise<any>*/
  {
    const {
      propertyId,
      businessId
    } = this.context.serialize();
    const path = propertyId ? `/properties/${propertyId}/hmacs/${hmacId}` : `/businesses/${businessId}/hmacs/${hmacId}`;
    const req = new this.client.Request(path, {}, []);
    return this.client.delete(req);
  }

}

module.exports = HmacsRepo;